import { FAQ_ITEMS, FEATURES_ITEMS, ABOUT_CONTENT } from '@/mocks/home';

export function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
          常见问题
        </h2>
        <div className="space-y-3">
          {FAQ_ITEMS.map((item, idx) => (
            <details key={idx} className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between px-5 py-4 text-foreground-900 font-medium text-sm md:text-base list-none">
                <span>{item.question}</span>
                <i className="ri-arrow-down-s-line text-lg text-foreground-500 group-open:rotate-180 transition-transform"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          平台优势
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          为什么5000万用户选择555电影网？三大核心优势为您揭晓
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FEATURES_ITEMS.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg p-6 md:p-8 text-center">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-background-100 rounded-lg p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              移动观影
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              555电影网全面适配手机与平板设备，无论您使用iOS还是Android，
              打开浏览器即可畅享高清电影。触屏优化界面，横竖屏自由切换，
              让您随时随地享受影院级观影体验。
            </p>
            <div className="flex items-center justify-center md:justify-start gap-3 flex-wrap">
              <a href="#hero" className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line"></i>
                iOS 网页版
              </a>
              <a href="#hero" className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-500 hover:bg-secondary-600 text-white text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line"></i>
                Android 网页版
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-40 h-72 md:w-48 md:h-80 rounded-2xl overflow-hidden border-4 border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20movie%20streaming%20app%20interface%20with%20warm%20dark%20cinematic%20theme%2C%20movie%20poster%20thumbnails%2C%20elegant%20minimal%20design%2C%20amber%20accent%20colors%2C%20clean%20layout%2C%20modern%20mobile%20UI&width=400&height=700&seq=app-phone-01&orientation=portrait"
                alt="555电影网移动端观影界面展示"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-600 mb-8 max-w-lg mx-auto">
          如有影片推荐、内容合作、问题反馈等需求，欢迎通过以下方式联系我们
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#hero" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-mail-line"></i>
            发送邮件
          </a>
          <a href="#faq" className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 hover:bg-background-200 text-foreground-800 font-medium text-sm rounded-md border border-background-300/60 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-question-answer-line"></i>
            查看常见问题
          </a>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8">
          关于555电影网
        </h2>
        <div className="space-y-4 text-sm text-foreground-600 leading-relaxed mb-10">
          {ABOUT_CONTENT.paragraphs.map((p, idx) => (
            <p key={idx}>{p}</p>
          ))}
        </div>
        <div className="grid grid-cols-3 gap-6">
          {ABOUT_CONTENT.stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600 mb-1">{stat.value}</div>
              <div className="text-xs text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}